import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
// import FormDialog from '../../../components/table/FormDialog';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';
import DataTable from '../common/view';
import SearchBox from '../../../../components/table/SearchBox';
import FormDialog from '../../../../components/table/FormDialog';
import { CommonConfig } from '../../../../config/common-config';
import token from '../../../../config/token';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ClosedTickets(props) {
    const history = useHistory();
    // const [AllImcs, setAllImcs] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    // const [deletedata, setDeleteData] = useState(rows);
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const vertical = 'top';
    const horizontal = 'center';
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;

    // const [selectedImc, setselectedImc] = useState(dbname);
    const classes = useStyles();

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const tokens = token();
    const myRef = useRef();
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [rows, setClosedTicketList] = useState([]);
    const [searchData, setSearchData] = useState([]);

    //console.log("dbname", dbname);
    //console.log("selectedImc", selectedImc);
    //console.log("usertype", usertype);

    let headCells = [];
    if (usertype === 'SUPERADMIN') {
        headCells = [
            { id: 'ticketId', label: 'Ticket Number' },
            { id: 'clientId', label: 'Client ID' },

            { id: 'clientName', label: 'Client Name' },
            { id: 'issueId', label: 'Issue relates to', isConcat: 'true', concatElem: ['issueType'] },
            { id: 'ticketTimestamp', label: 'Date' },
            { id: 'assigneeUserName', label: 'Assigned to' },
            { id: 'statusId', label: 'Current Status', isConcat: 'true', concatElem: ['statusText'] },
            { id: 'areyouHappy', label: 'Feedback' },
        ];
    } else {
        headCells = [
            { id: 'ticketId', label: 'Ticket Number' },
            { id: 'clientId', label: 'Client ID' },

            { id: 'clientName', label: 'Client Name' },
            { id: 'issueId', label: 'Issue relates to', isConcat: 'true', concatElem: ['issueType'] },
            { id: 'ticketTimestamp', label: 'Date' },
            { id: 'statusId', label: 'Current Status', isConcat: 'true', concatElem: ['statusText'] },
            { id: 'areyouHappy', label: 'Feedback' },
        ];
    }

    function formatDate(props) {
        return props.map((element) => {
            if (element && element.ticketTimestamp) {
                element.ticketTimestamp = moment(element.ticketTimestamp).format('DD-MM-YYYY hh:mm:ss');
            }
        });
    }

    const getClosedTicketList = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        const bearerToken = `Bearer ${userToken}`;

        let baseURL = '';
        if (usertype === 'SUPERADMIN') {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_all_completed/${
                props.selectedImc === 'itec' ? 'ITEC' : props.selectedImc
                }?page=${page}&size=10&sort=modifiedOn,asc`;
        } else if (usertype === 'itec') {
            if (props.selectedImc === 'itec') {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get_assigned_ticket_all_completed?page=${page}&size=10&sort=modifiedOn,asc`;
            } else {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get_assigned_ticket_all_completed/${props.selectedImc}?page=${page}&size=10&sort=modifiedOn,asc`;
            }
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_completed/${dbname}?page=${page}&size=10&sort=modifiedOn,asc`;
        }

        axios
            .get(baseURL, tokens)
            .then((response) => {
                console.log('response CLOSED TICKET LIST', response.data);
                // formatDate(response.data.content);
                // scrollTop();
                setClosedTicketList(response.data.content);
                setPageDetails(response.data);
                //  setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    useEffect(() => {
        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
        } else {
            setSearchData([]);
            getClosedTicketList();
        }
    }, [userToken, page, tokens, props.selectedImc]);

    // const { breadCrumbLabel, breadCrumbPath } = props;

    // useEffect(() => {
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //         })
    //         .then((response) => {
    //             //console.log('response.Chandra', response.data.content);
    //             setPendingInvoices(response.data.content);
    //         })
    //         .catch((error) => {});
    // }, [bearerToken, triggerUseEffect]);

    // componentDidMount() {
    //     this.getCandidates();
    //     this.props.history.push({
    //         state: { breadCrumb_label: this.props.breadCrumb_label }
    //     });
    // }

    // const HandleImcChange =(e)=> {
    // alert(e.target.value);

    // };

    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
        if (searchData && searchData.length > 2) {
            getSearchValue(searchData);
            return true;
        }
        if (!searchData) {
            setSearchData([]);
            setPage(0);
            getClosedTicketList();
        }
    };

    const getSearchValue = (data) => {
        let baseURL = '';
        if (usertype === 'SUPERADMIN') {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/support_ticket_all_completed/${props.selectedImc}?search=${data}&page=${page}&size=10&sort=modifiedOn,asc`;
        } else if (usertype === 'itec') {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/get_assigned_ticket_all_completed/${props.selectedImc}?search=${data}&page=${page}&size=10&sort=modifiedOn,asc`;
        } else if (usertype === 'ADMIN') {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/support_ticket_completed/${dbname}?search=${data}&page=${page}&size=10&sort=modifiedOn,asc`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/support_ticket_usercompleted/${dbname}?search=${data}&page=${page}&size=10&sort=modifiedOn,asc`;
        }
        axios
            .get(baseURL, tokens)
            .then((res) => {
                console.log('responseresponse', res);
                if (res.data) {
                    // console.log('responseresponse11', res.data.content.length);
                    if (res.data.content.length === 0) {
                        // console.log('responseresponse', res.data.content.length);
                        setClosedTicketList([]);
                    }
                    // formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => { });
    };

    const navigate = () => {
        history.push('/menu/raise-ticket');
    };

    const handleSave = () => { };

    const handleClose = () => {
        setOpenBox(false);
    };

    const handleSelectedValue = (val) => { };

    const handleCount = (val) => {
        if (val === 'prev') {
            if (!pageDetails.first) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (!pageDetails.last) {
                setPage((page) => page + 1);
            }
        }
    };

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getClosedTicketList();
    };

    // const handleDelete = (data) => {
    //     if (data.empId) {
    //         axios
    //             .delete(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith/${selectedImc}/${data.empId}`)
    //             .then((response) => {
    //                 const { status } = response;
    //                 if (status === 200) {
    //                     const list = rows.filter((m) => m.empId !== data.empId);
    //                     setDeleteData({ rows: list });
    //                     setDeleteMsg('Core employee deleted successfully');
    //                     setOpenBox(true);
    //                 }
    //             })
    //             .catch((e) => {
    //                 //console.log(e);
    //             });
    //     }
    // };

    // const navigate = () => {
    //     history.push('/menu/Core');
    // };
    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
    //     return OptionList;
    // };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith/${e.target.value}?page=0&size=1000&sort=empId,desc`)
    //         .then((response) => {
    //             //console.log("response", response.data.content);
    //             setTotalReactPackages(response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             if (error.response.data) {
    //                 setTotalReactPackages([]);
    //             }
    //         });
    // };
    // const { searchQuery } = props;
    // const filtered = searchQuery ? rows.filter((row) => row.firstName.toLowerCase().startsWith(searchQuery.toLowerCase())) : rows;

    // Filtered Row query , but if there are any empty rows doesn't work
    // as per functionality of "some" it should have value

    // const filteredRow = searchQuery
    //     ? rows.filter((row) => {
    //           const query = searchQuery.toLowerCase().trim();
    //           //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
    //           return headCells
    //               .map((col) => col.id)
    //               .some((key) => {
    //                   //console.log(row[key],"Value of ROW****row[key]");
    //                   return row[key].toString().toLowerCase().includes(query);
    //               });
    //       })
    //     : rows;

    // Filtered Row based on search for nested objects
    // const filteredRow = searchQuery
    //     ? rows.filter((searchRow) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headCells
    //             .map((col) => col)
    //             .some((key) => {
    //                 if (key.isConcat && searchRow[key.id]) {
    //                     const subdata = searchRow[key.id];
    //                     const mergedData = key.concatElem.map((concatdata) => {
    //                         return concatdata.split('.').reduce((acc, item) => {
    //                             if (Object.prototype.hasOwnProperty.call(acc, item)) {
    //                                 if (typeof acc[item] !== 'object') {
    //                                     return acc[item].toString().toLowerCase().includes(query);
    //                                 }
    //                                 return acc[item];
    //                             }

    //                             return false;
    //                         }, subdata);
    //                     });
    //                     //console.log(mergedData,"mergeData");

    //                     return mergedData[0];
    //                 }
    //                 if (searchRow[key.id]) {
    //                     return searchRow[key.id].toString().toLowerCase().includes(query);
    //                 } else {
    //                     return false;
    //                 }
    //             });
    //     })
    //     : rows;

    const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <>
            <Snackbar open={openBox} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar>

            <Card className="custom-table">
                <>
                    <div>
                        {/* <Grid container className="main-container field-container"></Grid> */}

                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Closed Tickets</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox
                                        searchQuery={searchQuery}
                                        onChange={handleSearchQuery}
                                        clearField={clearField}
                                        placeholder="Search..."
                                    />
                                </div>
                            </Grid>
                            <FormDialog row={[]} pageName="core" show="AddIcon" />
                        </CardContent>
                    </div>
                    <CardContent className="card-table-display">
                        {rows && filteredRow.length > 0 ? (
                            <>
                                <DataTable
                                    rows={filteredRow}
                                    headCells={headCells}
                                    saveRow={handleSave}
                                    axiosConfig={bearerToken}
                                    tennantName={dbname}
                                    handleCount={handleCount}
                                    //id={invoiceId}
                                    pageName="core"
                                    action
                                    pageDetails={pageDetails}
                                    prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                    imcType={props.selectedImc}
                                    ticketType={'closedTickets'}
                                    handleSelectedValue={handleSelectedValue}
                                />
                            </>
                        ) : (
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            )}
                    </CardContent>
                </>
            </Card>
        </>
    );
}
export default ClosedTickets;
